import { render } from "./ViewBesc.vue?vue&type=template&id=4374ec8f&scoped=true&ts=true"
import script from "./ViewBesc.vue?vue&type=script&lang=ts"
export * from "./ViewBesc.vue?vue&type=script&lang=ts"

import "./ViewBesc.vue?vue&type=style&index=0&id=4374ec8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4374ec8f"]])

export default __exports__